// extracted by mini-css-extract-plugin
module.exports = {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__2xQl6","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__2ArPw"};